import { useEffect } from "react";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import "./App.css";

import { RouterComponent } from "./RouterComponent";
import { InfoHorizentalMode } from "./components/InfoHorizentalMode/InfoHorizentalMode";
import { redirectToSavedConfigurator } from "./function/base/redirectToSavedConfigurator";
import { setActiveSubcategory, setEffectiveAccountId, setIsInStore, setUserType } from "./redux/features/ui/uiSlice";
import { getEffectiveAccountId } from "./redux/selectors/ui.selector";
import { useAppDispatch, useAppSelector } from "./utils/hooks";
import { caseInsensitiveParams } from "./utils/ui/urlParams";
declare global {
  interface Window {
    player: any;
    playerT: any;
    configurator: any;
    threekitPlayer: any;
    constantsUI: any;
  }
}
export const ConfiguratorApp = ({ ...props }: any) => {
  const effectiveAccountIdStore = useAppSelector(getEffectiveAccountId);
  redirectToSavedConfigurator();
  const dispatch = useAppDispatch();
  useEffect(() => {
    // Retrieve `effectiveAccountId` from URL search parameters. Keys are matched case-insensitively
    // because these links are generated by external systems.
    const urlParams = caseInsensitiveParams(window.location.search);
    const effectiveAccountId = urlParams.get("effectiveAccountId") || "";
    const subcategory = urlParams.get("subCategory") || "";

    // Persist the wholesale / in-store context for the session. Some "back to start"
    // navigations reload the page without these query params; falling back to the persisted
    // value keeps the session consistent (and keeps the wholesale SKU-order tool visible)
    // instead of resetting to defaults. An explicit URL param always wins.
    const inStoreParam = urlParams.get("inStore");
    const userTypeParam = urlParams.get("userType")?.toLowerCase();

    const inStore =
      inStoreParam !== null ? inStoreParam === "true" : window.sessionStorage.getItem("inStore") === "true";
    const priceUserType =
      (userTypeParam ?? window.sessionStorage.getItem("userType") ?? "") === "wholesale" ? "wholesale" : "retail";

    window.sessionStorage.setItem("inStore", String(inStore));
    window.sessionStorage.setItem("userType", priceUserType);

    dispatch(setIsInStore(inStore));
    dispatch(setUserType(priceUserType));

    if (subcategory) {
      dispatch(setActiveSubcategory(subcategory));
    }

    if (effectiveAccountId && effectiveAccountIdStore === "DEFAULT") {
      // Dispatch the action to set it in the Redux store
      dispatch(setEffectiveAccountId(effectiveAccountId.toUpperCase()));
    } else {
      console.warn("No effectiveAccountId found in the URL");
    }
  }, []);
  return (
    <div className="app">
      <InfoHorizentalMode />
      <RouterComponent />
    </div>
  );
};
